__turbopack_context__.v({
  "bubbleTitle": "Ingredients-module-scss-module__fa7CUG__bubbleTitle",
  "fade-in": "Ingredients-module-scss-module__fa7CUG__fade-in",
  "heading": "Ingredients-module-scss-module__fa7CUG__heading",
  "ingredientBubble": "Ingredients-module-scss-module__fa7CUG__ingredientBubble",
  "ingredientBubble--open": "Ingredients-module-scss-module__fa7CUG__ingredientBubble--open",
  "ingredients": "Ingredients-module-scss-module__fa7CUG__ingredients",
  "list": "Ingredients-module-scss-module__fa7CUG__list",
  "theme--makers-reserve": "Ingredients-module-scss-module__fa7CUG__theme--makers-reserve",
  "toolTip": "Ingredients-module-scss-module__fa7CUG__toolTip",
});
